const extractDomainFromString = (fullDomain) => {
  const firstDot = fullDomain.indexOf(".");

  if (firstDot === -1) {
    return false;
  }

  return {
    domain: fullDomain.substring(0, firstDot),
    tld: fullDomain.substring(firstDot),
  };
};

export default extractDomainFromString;
